import { connect } from "react-redux";
import { getCategoryBreadcrumbs } from "../../state/modules/category/selectors";
import CategoryOutOfStock from "../../components/CategoryOutOfStock";

const mapStateToProps = state => ({
  breadcrumbs: getCategoryBreadcrumbs(state)
});

export default connect(mapStateToProps)(CategoryOutOfStock);
